import request from '@/utils/request';


// 主试激活
export function Activation(data) {
  return request({
    url: '/adapt/activation',
    method: 'POST',
    data
  });
}

// 检测账号
export function VerifyAccount(params) {
  return request({
    url: '/adapt/activation/verifyAccount',
    method: 'GET',
    params
  });
}